import React from 'react';
import * as ROUTES from '../../constants/routes';
import './BrandKit.css';

const OFFICIAL_BRAND_KIT_URL = 'https://dijon-baton-88305262.figma.site/';

const BrandKit = ({ showOpenInNewPageButton = true, fullBleed = false }) => {
  const handleOpenStandalone = () => {
    if (typeof window === 'undefined') return;
    const standaloneUrl = `${window.location.origin}${ROUTES.FRANCHISE_BRAND_KIT_VIEW}`;
    const newTab = window.open(
      standaloneUrl,
      '_blank',
      'noopener',
    );
    if (newTab) {
      try {
        newTab.opener = null;
      } catch (e) {
        // No-op: some browsers restrict this assignment.
      }
    }
  };

  return (
    <div className={`brandkit-embed-wrapper${fullBleed ? ' brandkit-embed-wrapper--full' : ''}`}>
      {showOpenInNewPageButton ? (
        <div className="brandkit-open-row">
          <button type="button" className="brandkit-open-button" onClick={handleOpenStandalone}>
            Open Brand Kit in New Page
          </button>
        </div>
      ) : null}
      <div className={`brandkit-embed-shell${fullBleed ? ' brandkit-embed-shell--full' : ''}`}>
        <iframe
          className={`brandkit-embed-frame${fullBleed ? ' brandkit-embed-frame--full' : ''}`}
          src={OFFICIAL_BRAND_KIT_URL}
          title="Douglas McCartney Brand Kit"
          loading="eager"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    </div>
  );
};

export default BrandKit;
